import React from 'react';

const Anchor = (
  props: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > & { to?: string },
) => {
  return <a {...props} href={props.to} />;
};

export default Anchor;
